import React from 'react'
import { Col, Form, Row, Button } from 'react-bootstrap';
import styled from 'styled-components'
import Comment from '../../../Utilitis/Comment/Comment';

const CommentCourse = styled.div`
margin-top: 20px;
box-shadow: 1px 1px 4px #ececec, -1px -1px 4px #dfdfdf;
background-color: white;
h6{
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #b7b5b5;
    padding: 14px 20px;
}
`;

const FormCours = styled(Form)`
padding: 10px 20px;
textArea{
    height: 150px;
}
hr{
    margin:0;
}
`;

const CourseComments = styled.div`
padding: 10px 20px;
background-color: white;
`;
export default function CourseComment() {
    return (
        <CommentCourse>
            <h6>Lave Comment</h6>
            <FormCours>
                <Row>
                    <Form.Group as={Col} className="mb-3" >
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter Your FullName" />
                    </Form.Group>
                    <Form.Group as={Col} className="mb-3" >
                        <Form.Label>Your Email</Form.Label>
                        <Form.Control type="email" placeholder="Enter Your Email" />
                    </Form.Group>
                </Row>
                <Form.Group as={Col} className="mb-3" >
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control as="textarea" placeholder="Leave a comment here" />
                </Form.Group>
                <Button variant="primary" type="submit">
                    Send Comment
                </Button>
            </FormCours>
            <hr />
            <h6>Post Comment</h6>
            <CourseComments>
                <Comment />
                <Comment />
            </CourseComments>
        </CommentCourse>
    )
}
